export default __webpack_public_path__ + "3fab27b9bae0c4035e713926795b88df.svg";